import { render, staticRenderFns } from "./studentSubscription.vue?vue&type=template&id=5ce491c3"
import script from "./studentSubscription.vue?vue&type=script&lang=js"
export * from "./studentSubscription.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports